<template>
    <div class="teachCenter">
      <!--面包屑-->
      <div class="crumbs">
        <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
        <span>教学中心</span>
      </div>
      <!--搜索框-->
      <div class="search">
        <!--分类选择-->
        <div class="hospital-select">
          <!--tab切换-->
          <div class="tabContent">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="精品好课" name="first"><span></span>
                <courseType @checkCourse="checkCourse" @subjectCourse="subjectCourse" :active="activeName"></courseType>
              </el-tab-pane>
              <!--名师讲堂-->
              <el-tab-pane label="名师讲堂" name="second">
                <div class="check-type">
                  <em class="label">医生职称:</em>
                  <el-checkbox-group v-model="docName">
                    <el-checkbox-button v-model="docName" value="" label="" key="全部" @change="handleTitAllchange">全部
                    </el-checkbox-button>
                    <el-checkbox-button v-for="(doc,index) in docNameList" :label="doc.consId" :key="doc.consId" @change="handleTitChange">
                      {{docNameList[index].showZN}}
                    </el-checkbox-button>
                  </el-checkbox-group>
                </div>
                <div class="check-type sel-hospital">
                  <em class="label">所属医院:</em>
                  <el-select v-model="hosVal" placeholder="请选择">
                    <el-option :label="'全部'" :key="''" :value="''">全部</el-option>
                    <el-option
                      v-for="item in optionsVal"
                      :key="item.hosId"
                      :label="item.hosName"
                      :value="item.hosId">
                    </el-option>
                  </el-select>
                </div>
              </el-tab-pane>
              <el-tab-pane label="我的收藏" name="third">
                <courseType @checkCourse="checkCourse" @subjectCourse="subjectCourse" :active="activeName"></courseType>
              </el-tab-pane>
              <el-tab-pane label="我的学习" name="fourth">
                <courseType @checkCourse="checkCourse" @subjectCourse="subjectCourse" :active="activeName"></courseType>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="rightSearch">
            <input v-model="keyword" class="radius_input" placeholder="搜索课程/专家" type="text" @keyup.enter="search">
            <i class="pointer el-icon-search" @click="search"></i>
          </div>
          <!--观看最多-->
          <div v-show="activeName === 'first'" class="praiseMore">
            <el-select v-model="orderRule1" placeholder="观看最多" @change="changeVal">
              <el-option
                v-for="item in options"
                :key="item.consId"
                :label="item.consDesc"
                :value="item.consId">
              </el-option>
            </el-select>
          </div>
          <!--查询按钮-->
          <div class="queryBtn" @click="search">查询</div>
          <!--点赞最多-->
          <div v-show="activeName === 'second'" class="praiseMore">
            <el-select v-model="orderRule2" placeholder="点赞最多" @change="changeVal">
              <el-option
                v-for="item in options2"
                :key="item.consId"
                :label="item.consDesc"
                :value="item.consId">
              </el-option>
            </el-select>
          </div>
        </div>
        <!--精品好课列表-->
        <div v-show="activeName === 'first'||activeName === 'third'||activeName === 'fourth'">
          <teachCard :active="activeName" @trigger="trigger" :tecahCardList="tecahCardList"  @popShow="routerShow1"></teachCard>
        </div>
        <!--名师讲堂列表-->
        <div class="famousList" v-show="activeName === 'second'">
          <famousCard :famousList="famousList" @popShow2="routerShow2" @popShow="routerShow1" ></famousCard>
        </div>
        <!--精品好课与名师讲堂分页-->
        <div class="paging">
          <page v-show="activeName === 'first'||activeName === 'second'||activeName === 'third'||activeName === 'fourth'" :total="page.total" :allPage="page.allPage" :currentPage="page.currentPage" @current-page="__currentPage"
                @page-size="__pageSize" :current="'tenchCenter'" :pageSize2="page.pageSize" ></page>
        </div>
      </div>


    <right-pops v-if="popShow">
      <router-view/>
    </right-pops>
  </div>
</template>

<script type="text/ecmascript-6">
  import courseType from '@/components/common/courseType/courseType'
  import teachCard from '@/components/common/card/teachCard'
  import famousCard from '@/components/common/famousCard/famousCard'
  import rightPops from '@/components/common/right/rightPops'
  import * as _ from '@/common/js/config'
  import router from '../../../../router'
  import http from '@/api/http'
  import page from '@/components/common/page/page'
  export default {
    components: {
      courseType,
      teachCard,
      page,
      rightPops,
      famousCard
    },
    data() {
      return {
        activeName: 'first',
        docNameList: [],
        checkType: '',
        subjectType: '',
        popShow:false,
        docTitle:'',
        docName: [''],
        optionsVal: [],
        tecahCardList: [],
        famousList: [],
        page: {
          currentPage: 1,
          pageSize: 20,
          total: 20,
          allPage: 0
        },
        options: [],
        options2: [],
        keyword: '',
        orderRule1: '1',
        hosVal: '',
        orderRule2: '2'
      }
    },
    watch: {
      // popShow(c) {
      //   if (c === false) {
      //   this.getCourse(this.page.currentPage)
      //   }
      // },
      activeName(c){
        // console.log(this.page.pageSize)
        if(c==='second'){
          this.hospitalList()
          this.titleList()
          this.currList()
        } else if(c==='first'){
          this.sortList()
        }
      },

    },
    mounted() {
        setTimeout(() => {
          this._routerEach()
          if (this.$route.name === 'TeachCenter') {
            this.popShow = false
          }else if (this.$route.name === 'TeachDetail'){
            this.popShow = true
          }
           else {
            this.popShow = true
          }
        }, 20)
    },
    methods: {
      checkCourse(val){
        if(val[0]===''){
          this.checkType = []
        } else {
          this.checkType = val
        }
      },
      subjectCourse(val){
        if(val[0]===''){
          this.subjectType = []
        } else {
          this.subjectType = val
        }
      },
      changeVal(){
        this.commonJudge()
      },
      trigger(){
        this.commonJudge()
      },
      search(){
        this.commonJudge()
      },
      handleClick(tab, event) {   //导航切换
        this.checkType = ''
        this.keyword = ''
        this.subjectType = ''
        this.search()
      },
      handleTitAllchange(val) {   //医生职称切换
        this.docName = val ? [''] : []
      },
      handleTitChange(value) {
        let index = this.docName.indexOf(String(''))
        if (index != -1) {
          this.docName.splice(index, 1)
        }
        if (!value) {
          if (this.docName.length == 0) {
            this.docName = ['']
          }
        }
      },
      commonJudge(){     //公用判断
            if(this.activeName==='first'){
              let url = '/studyCenter/getCourseListByClasis.json'
              this.page.pageSize = 20
              this.searchList(url)
            } else if(this.activeName ==='second') {
              // console.log(this.docName)
              this.page.pageSize = 10
              this.searchTeach()
            }else if(this.activeName==='third') {
              let url = '/studyCenter/getMyCollections.json'
              this.page.pageSize = 20
              this.searchList(url)
            } else if(this.activeName==='fourth') {
              let url = '/studyCenter/getMyLearned.json'
              this.page.pageSize = 20
              this.searchList(url)
            }
      },
      searchTeach(){     //名师讲堂查询接口
        let params = {
          dotorTitle: this.docName,
          hospitalId: this.hosVal,
          keyWord: this.keyword,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
          orderRule: this.orderRule2
        }
        if(this.docName.length===0||this.docName[0]==='') delete params.dotorTitle
        if(this.keyword === '') delete params.keyWord
        if(this.hosVal === '') delete params.hospitalId
        http.post('/studyCenter/getCourseGroupByDoctor.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.famousList = res.data.model
            this.page.total = res.data.totalItem

            // for (let i in res.data.model){
            //   if
            // }
           let p = {
              typeId:'EDU_DOCTORTITLE'
            }
            http.post('/system/queryEduContantByTypeId.json', p).then(res => {
              if (res.data.code === _.ERR_OK) {
                this.famousList.forEach( ele => {
                  // console.log(ele.professionTitle)
                   for(let i of res.data.model){
                    if(ele.professionTitle == i.consId){
                      ele.professionTitle = i.consDesc
                    }else if(ele.professionTitle === undefined){
                      ele.professionTitle = ''
                    }
                   }
                })
              }else{

              }
            })
          } else {
            this.famousList = []
            this.page.total = 0
          }
        })

      },
      searchList(val){   //精品好课、我的收藏、我的学习列表查询接口
        let params = {
          courseType: this.checkType,
          scienceType: this.subjectType,
          keyWord: this.keyword,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
          orderRule: this.orderRule1
        }
        if(this.checkType.length===0) delete params.courseType
        if(this.subjectType.length===0) delete params.scienceType
        if(this.keyword === '') delete params.keyWord
        if(this.activeName==='third'||this.activeName==='fourth') delete params.orderRule
        http.post(val, params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.tecahCardList = res.data.model
            this.page.total = res.data.totalItem
          } else {
            this.tecahCardList = []
            this.page.total = 0
          }
        })
      },
      __currentPage(payload) { //选择页数
        this.page.currentPage = payload
        this.commonJudge()
      },
      __pageSize(payload) {  //选择每页多少条
        this.page.pageSize = payload
            if(this.activeName==='first'){
              let url = '/studyCenter/getCourseListByClasis.json'
              // this.page.pageSize = 20
              this.searchList(url)
            } else if(this.activeName ==='second') {
              // console.log(this.docName)
              // this.page.pageSize = 10
              this.searchTeach()
            }else if(this.activeName==='third') {
              let url = '/studyCenter/getMyCollections.json'
              // this.page.pageSize = 20
              this.searchList(url)
            } else if(this.activeName==='fourth') {
              let url = '/studyCenter/getMyLearned.json'
              // this.page.pageSize = 20
              this.searchList(url)
            }

      },
      titleList(){   //医生职称常量列表
        let params = {
          typeId: 'EDU_DOCTORTITLE'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.docNameList = res.data.model
          } else {
          }
        })
      },
      sortList(){   //精品好课点赞最多常量列表
        let params = {
          typeId: 'EDU_COURSEORDER'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            res.data.model.splice(3, 1)
            this.options = res.data.model
          } else {
          }
        })
      },
      currList(){  //名师讲堂课程最多常量列表
        let params = {
          typeId: 'EDU_COURSEORDER'
        }
        http.post('/system/queryEduContantByTypeId.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            res.data.model.splice(2, 1)
            this.options2 = res.data.model
          } else {
          }
        })
      },
      hospitalList(){   //所属医院列表
        http.post('/system/queryAllHosList.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            this.optionsVal = res.data.model
          } else {
          }
        })
      },
      _routerEach() {
        router.beforeEach((to, from, next) => {
          if (from.name === 'TeachCenter' ) {
            this.popShow = true
          }else if(from.name === 'TeachDetail'  && to.name ===  'CourseEvaluat'){
            this.popShow = true
          }else if( from.name === 'CourseEvaluat' && to.name ===  'TeachDetail'){
            this.popShow = true
          }else {
            this.popShow = false
          }
          next()
        })
      },
      routerShow1(val){
        this.popShow = val
        // alert(this.popShow)
        this.$router.push({name: 'CourseEvaluat'})
      },
      routerShow2(val){
        this.popShow = val
        // alert(this.popShow)
        this.$router.push({name: 'TeachDetail'})
      }
    },
    created() {
      this.search()
      this.sortList()
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .teachCenter
    .check-type
      height: 32px
      line-height: 32px
      width: 100%
      color: #000
      em
        font-style: normal
        width: 66px
        height: 32px
        margin-right: 6px
        color: $color-text
        float: left
      > li
        float: left
        label
          cursor: pointer;
          padding: 0 6px
        span
          color:#9d9ea3
    .praiseMore
      position: absolute
      top: 63px
      right: 12px
      width: 101px
    .queryBtn
      position: absolute
      right: 23px
      bottom: 12px
      width: 80px
      text-align: center
      height: 25px
      line-height: 25px
      background: $color-green
      border-radius: 4px
      color: #fff
      cursor: pointer
    .rightSearch
      width: 30%
      position: absolute
      top: 30px
      right: 0
      .radius_input
        min-width: 200px
        width: 70%
        background: #f2f2f2
        height: 24px
        border-radius: 20px
        position: absolute
        right: 20px
        top: -19px
        padding: 0 20px
      .pointer
        position: absolute
        right: 30px
        top: -14px
        cursor: pointer
  .famousList
    background: #fff
    margin: 17px 0
</style>



// WEBPACK FOOTER //
// teachCenter.vue?d1575e9c